import { render, staticRenderFns } from "./selectSpecDlg.vue?vue&type=template&id=72fb323d&scoped=true"
import script from "./selectSpecDlg.vue?vue&type=script&lang=js"
export * from "./selectSpecDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fb323d",
  null
  
)

export default component.exports